module.exports = __webpack_public_path__ + "img/2012-08-18 17.08.38.8c470eb9.jpg";